// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import styles from './Spinner.module.scss';

/** @type { StatelessComponent<{}> } */
const Spinner = () => <div className={styles.spinner} />;

Spinner.displayName = 'Spinner';

export default Spinner;
